import { useAuth } from '../context/AuthContext';

/**
 * Hook to get permission level for a menu key.
 * Returns { canRead, canWrite, canEdit, canDelete, isAdmin, hasAccess }
 *
 * Usage in a page:
 *   const { canRead, canWrite, canEdit, canDelete } = usePermission('packing');
 *
 * If user is admin → all true
 * If worker has no permission for this key → all false (page should show 403)
 */
export default function usePermission(menuKey) {
  const { user, permissions } = useAuth();

  if (!user) {
    return { canRead: false, canWrite: false, canEdit: false, canDelete: false, isAdmin: false, hasAccess: false };
  }

  if (user.role === 'admin') {
    return { canRead: true, canWrite: true, canEdit: true, canDelete: true, isAdmin: true, hasAccess: true };
  }

  const perm = permissions?.[menuKey] || {};
  const canRead = !!perm.can_read;
  const canWrite = !!perm.can_write;
  const canEdit = !!perm.can_edit;
  const canDelete = !!perm.can_delete;

  return {
    canRead,
    canWrite,
    canEdit,
    canDelete,
    isAdmin: false,
    hasAccess: canRead || canWrite || canEdit || canDelete,
  };
}
